/*
Item: StructureCard Components for Drag'n'Drop in Statistics.jsx
Name: StructureCard
Format: Code/Frontend component
*/

import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';
import { DragSource, DropTarget } from 'react-dnd';
import flow from 'lodash/flow';

const style = {
  padding: '0.1rem 0rem 0rem 0.25rem',
  margin: '.2rem',
  backgroundColor: '#757575',
  color: 'white',
  cursor: 'move',
  borderRadius: '4px',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
};

const nameStyle = {
  width: '136px',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  display: 'inline-block',
};
const middleStyle = {
  width: '40px',
  height: '20px',
  overflow: 'hidden',
  display: 'inline-block',
};
const endStyleActive = {
  cursor: 'pointer',
  width: '20px',
  height: '20px',
  overflow: 'hidden',
  display: 'inline-block',
  color: 'white',
};
const endStyleDeactivated = {
  cursor: 'move',
  width: '20px',
  height: '20px',
  overflow: 'hidden',
  display: 'inline-block',
  color: '#9E9E9E',
};

class StructureCard extends Component {
  constructor(props) {
    super(props);
    this.showOverlay = this.props.showOverlay;
  }

  render() {
    const {
      card, isDragging, connectDragSource, connectDropTarget,
      activeRule, activeFilter, containerName,
    } = this.props;
    // const opacity = isDragging ? 0 : 1;
    const backgroundColor = isDragging ? '#D8D8D8' : '#757575'; // placeholder
    const color = isDragging ? '#D8D8D8' : 'white'; // placeholder
    // constant uniqueId is important for passing up-to-date value to showOverlay!
    const { text, uniqueId, code, name } = card;
    let { type } = card;
    let ruleColor;
    let isAverageMedian = card.isAverageMedian;
    // console.log('CARD#1', card.output[0].reference.type);
    if (type === 'VARIABLE') type = card.output[0].reference.type;
    // console.log('CARD#1', card);
    let instantReturn = ((type === 'VALUE' && name !== 'VZAE') && !isAverageMedian) || type === 'STATISTIC';
    // instantReturn = false;
    // console.log('connectDragSource#', isAverageMedian);
    if (containerName === 'filter' || containerName === 'headings'
      || type === 'VALUE' || type === 'TIME_CLASSIFYING' || type === 'TIME_IDENTIFYING') {
      ruleColor = '#757575';
    } else if (activeRule) {
      ruleColor = 'white';
    } else {
      ruleColor = '#9E9E9E'; // hidden
    }
    let endStyle = endStyleActive;
    if (instantReturn) endStyle = endStyleDeactivated; // ADBHSSTAT-1642
    const filterColor = activeFilter ? 'white' : '#9E9E9E'; // color of filter icon
    return connectDragSource(connectDropTarget(
      <div
        title={text}
        style={{ ...style, /* opacity */ backgroundColor, color }}
      >
        <div style={{ ...nameStyle }}>
          {card.text}
        </div>
        {false
          ? <div />
          : (
            <div style={{ ...middleStyle }}>
            <i style={{ color: ruleColor }} className="pi pi-md-description" />
            <i style={{ color: filterColor }} className="pi pi-md-filter-list" />
            </div>
          )}
        <div
          onClick={(e) => this.showOverlay(e, code, uniqueId, type, containerName, instantReturn)}
          style={{ ...endStyle }}
        >
          <i className="pi pi-md-arrow-drop-down" />
        </div>
      </div>,
    ));
  }
}

const cardSource = {
  beginDrag(props) {
    return {
      index: props.index,
      listId: props.listId,
      card: props.card,
      containerName: props.containerName,
    };
  },

  endDrag(props, monitor) {
    const item = monitor.getItem();
    const dropResult = monitor.getDropResult();
    if (dropResult && dropResult.listId !== item.listId) {
      props.removeCard(item.index, props.containerName);
    }
  },
};

const cardTarget = {
  hover(props, monitor, component) {
    const dragIndex = monitor.getItem().index;
    const hoverIndex = props.index;
    const sourceListId = monitor.getItem().listId;
    const { containerName } = monitor.getItem();
    // Don't replace items with themselves
    if (dragIndex === hoverIndex) {
      return;
    }

    // Determine rectangle on screen
    const hoverBoundingRect = findDOMNode(component).getBoundingClientRect();
    // Get vertical middle
    const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
    // Determine mouse position
    const clientOffset = monitor.getClientOffset();
    // Get pixels to the top
    const hoverClientY = clientOffset.y - hoverBoundingRect.top;
    // Only perform the move when the mouse has crossed half of the items height
    // When dragging downwards, only move when the cursor is below 50%
    // When dragging upwards, only move when the cursor is above 50%
    // Dragging downwards
    if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
      return;
    }

    // Dragging upwards
    if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
      return;
    }

    // Time to actually perform the action
    if (props.listId === sourceListId) {
      props.moveCard(dragIndex, hoverIndex, containerName);
      // Note: we're mutating the monitor item here!
      // Generally it's better to avoid mutations,
      // but it's good here for performance
      // to avoid expensive index searches.
      monitor.getItem().index = hoverIndex;
    }
  },
};

export default flow(
  DropTarget('CARD', cardTarget, (connect) => ({
    connectDropTarget: connect.dropTarget(),
  })),
  DragSource('CARD', cardSource, (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
  })),
)(StructureCard);
